import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastrService } from 'ngx-toastr';
import { MailsService } from 'src/app/shared/services/mails.service';
import { IButton, TranslateService } from '@devinforius/i-essentials';

@Component({
  selector: 'app-archivage-modals',
  templateUrl: './archivage-modals.component.html',
  styleUrls: ['./archivage-modals.component.scss'],
})
export class ArchivageModalsComponent implements OnInit {
  public form = new UntypedFormGroup({
    boiteArchivage: new UntypedFormControl(null),
    courrierId: new UntypedFormControl(null),
  });

  public titleButtons: IButton[] = [
    {
      text: 'homeCourrier.buttons.back',
      styleClass: 'blue',
      click: () => {
        this.ref.close();
      },
    },
    {
      text: 'validate',
      styleClass: 'green',
      click: () => {
        this.submit();
      },
    },
  ];
  constructor(
    public ref: DynamicDialogRef,
    public toastr: ToastrService,
    private mailsService: MailsService,
    private translater: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
  }

  submit(): void {
    if (this.form.valid) {
      const data = {
        boiteArchive: this.form.value.boiteArchivage,
      };
      this.mailsService.patchBoiteArchive(this.form.value.courrierId, data).subscribe({
        next: () => {
          this.toastr.success('Archivage effectué avec succès !');
          this.form.patchValue({
            boiteArchivage: data.boiteArchive,
            courrierId: null,
          });
        },
        error: (error) => {
          if (error) {
            this.toastr.error("Vous n'avez pas le droit d'archiver ce courrier");
          }
        },
      });
    } else {
      this.toastr.error('Les champs requis ne sont pas complétés');
    }
  }
}
